import { render, staticRenderFns } from "./addAddress.vue?vue&type=template&id=71d396c2&scoped=true"
import script from "./addAddress.vue?vue&type=script&lang=js"
export * from "./addAddress.vue?vue&type=script&lang=js"
import style0 from "./addAddress.vue?vue&type=style&index=0&id=71d396c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d396c2",
  null
  
)

export default component.exports